'use client';

import { StableTimestamp } from '@/providers/stable-timestamp.provider';

/** Stable "now" for Nebuly page query payloads (refreshes every 15 minutes). */
export function useNebulyPageStableNow(): Date {
  const { getTimestamp } = StableTimestamp.useProvided();
  return getTimestamp();
}
